// SprintBattlesMobile.js
import React from "react";
import { getFlagUrl } from "./Utils/getFlagUrl";

const SprintBattlesMobile = ({ data, boldRows, rowRange }) => {
  const isSpacer = (row) => row.every(cell => !cell || cell.trim() === "");
  const visibleRows = data.slice(rowRange[0] - 1, rowRange[1]);

  const renderRider = (row, i) => {
    const rowNumber = rowRange[0] + i;
    const isBold = boldRows.includes(rowNumber);

    return (
      <div key={i} className={`sqm-row ${isBold ? "bold-row" : ""}`}>
        <div className="sqm-rank">{row[0]}</div>
        <div className="sqm-name">
          <div className="sqm-last-name">{row[2]}</div>
          <div className="sqm-first-name">{row[3]}</div>
        </div>
        <div className="sqm-right sqm-sprint-right">
          <div className="sprint-col sprint-flag">
            <img src={getFlagUrl(row[4])} alt={row[4]} className="flag-icon" />
          </div>
          <div className="sprint-col sprint-time">
            {row[5]}
          </div>
        </div>
      </div>
    );
  };

  const battles = [];
  for (let i = 0; i < visibleRows.length; i++) {
    const row = visibleRows[i];
    if (isSpacer(row)) continue;

    const next = data[i + 1];
    if (next && !isSpacer(next)) {
      battles.push([row, next]);
      i++;
    } else {
      battles.push([row]);
    }
  }

  return (
    <div className="mobile-sprint-battles">
      {battles.map((pair, index) => (
        <div key={index} className="sbm-battle">
          {pair.map((rider, idx) => renderRider(rider, index * 2 + idx))}
        </div>
      ))}
    </div>
  );
};

export default SprintBattlesMobile;
